import { useEffect, useState } from 'react';
import { selectionProcessesAdmin } from '@/services/selectionProcesses';
import { Input } from '@/components/ui/input';
import { Skeleton } from '@/components/ui/skeleton';
import ExportButtons from './ExportButtons';

const TABLE_HEAD = [
  { label: 'Protocolo', numeric: false },
  { label: 'Nome', numeric: false },
  { label: 'CPF', numeric: false },
  { label: 'Regional', numeric: false },
  { label: 'Unidade', numeric: false },
  { label: 'Data de inscrição', numeric: false },
];

function TableSkeleton() {
  return (
    <div className="space-y-2 pt-2">
      {Array.from({ length: 5 }).map((_, i) => (
        <Skeleton key={i} className="h-10 w-full rounded-md" />
      ))}
    </div>
  );
}

export default function RegistrationsTab({ processId, slug }) {
  const [items, setItems] = useState([]);
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    selectionProcessesAdmin
      .registrations(processId, filters)
      .then(res => setItems(res.data || []))
      .finally(() => setLoading(false));
  }, [processId, filters]);

  return (
    <div className="pt-4">
      {/* ── Toolbar ── */}
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <Input
          type="search"
          placeholder="Buscar por nome, CPF ou protocolo"
          className="max-w-xs"
          onChange={e => setFilters(f => ({ ...f, q: e.target.value }))}
        />
        <ExportButtons processId={processId} slug={slug} filters={filters} />
      </div>

      {/* ── Table ── */}
      {loading ? (
        <TableSkeleton />
      ) : (
        <div className="round-dg-wrapper">
          <table
            className="round-dg round-dg--light"
            style={{ borderSpacing: '0 10px' }}
          >
            <thead className="round-dg__header">
              <tr className="round-dg__row">
                {TABLE_HEAD.map((h, i) => (
                  <th
                    key={i}
                    className="round-dg__cell-header round-dg__cell-header--sm"
                  >
                    {h.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="round-dg__body">
              {items.length === 0 ? (
                <tr className="round-dg__row">
                  <td
                    colSpan={TABLE_HEAD.length}
                    className="round-dg__cell round-dg__cell--sm text-center"
                  >
                    Nenhum inscrito encontrado
                  </td>
                </tr>
              ) : (
                items.map(r => (
                  <tr key={r.id} className="round-dg__row">
                    <td className="round-dg__cell round-dg__cell--sm font-mono text-xs">
                      {r.attributes.protocol}
                    </td>
                    <td className="round-dg__cell round-dg__cell--sm">
                      {r.attributes.full_name}
                    </td>
                    <td className="round-dg__cell round-dg__cell--sm font-mono text-xs">
                      {r.attributes.cpf}
                    </td>
                    <td className="round-dg__cell round-dg__cell--sm">
                      {r.attributes.regional_id}
                    </td>
                    <td className="round-dg__cell round-dg__cell--sm">
                      {r.attributes.institution_id}
                    </td>
                    <td className="round-dg__cell round-dg__cell--sm tabular-nums">
                      {new Date(r.attributes.created_at).toLocaleString('pt-BR')}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
